export const appEnv = process.env.REACT_APP_LAYOUT_MANAGEMENT_KEY;
